<template>
    <el-date-picker size="small" v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="false"
        :picker-options="pickerOptions" @change="dateChange">
    </el-date-picker>
</template>

<script>
export default {
    name: 'DateSelects',
    data () {
        return {
            date: [],
            pickerOptions: {
                disabledDate: (time) => {
                    return time.getTime() > Date.now()
                }
            }
        }
    },
    // props: {
    //     date: {
    //         type: Array,
    //         defalut: []
    //     }
    // },
    mounted () {
        this.initDate()
    },
    methods: {
        dateChange (val) {
            this.date = val !== null ? val : ''
            this.$emit('dateChange', this.date)
        },
        initDate () {
            const date = new Date()
            const year = date.getFullYear()
            const month1 = date.getMonth() + 1
            const month2 = month1 > 9 ? month1 : '0' + month1
            const month3 = month1 - 1 > 9 ? month1 - 1 : '0' + (month1 - 1)
            const day1 = date.getDate()
            const day = day1 > 9 ? day1 : '0' + day1
            const end = `${year}-${month2}-${day}`
            const start = `${year}-${month3}-${day}`
            // this.start_time = start
            // this.end_time = end
            this.date = [start, end]
            this.$emit('dateChange', this.date)

        },
    }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/filterComponent/DateSelects.vue